'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var timeout = function timeout(promise, ms) {
  return Promise.race([promise, (0, _bluebird.delay)(ms + 50).timeout(ms)]);
};

exports.default = timeout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/timeout.js
// module id = 469
// module chunks = 0